import { AxiosResponse } from 'axios';

import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { prepareQPFromFilters, serverAxios } from '../../http';
import {
  IGetChargingPointOperatorsResponse,
  IGetChargingPointResponse,
  IGetChargingPointsByIdResponse,
  IGetChargingPointsFilters,
} from 'models/http/chargingPoint';

class ChargingPointHttp {
  private static route = '/chargingStations';

  public async get(filters: IGetChargingPointsFilters, abortController?: AbortController): Promise<IGetChargingPointResponse['records']> {
    const query = prepareQPFromFilters(filters);

    return serverAxios
      .get(`${ChargingPointHttp.route}?${query}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetChargingPointResponse['records']>) => {
        return response.data;
      });
  }

  public async getById(id: number, abortController?: AbortController): Promise<IGetChargingPointsByIdResponse> {
    return serverAxios
      .get(`${ChargingPointHttp.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetChargingPointsByIdResponse>) => {
        return response.data;
      });
  }

  public async getChargingPointOperators(abortController?: AbortController): Promise<IGetChargingPointOperatorsResponse> {
    return serverAxios
      .get(`${ChargingPointHttp.route}/operators`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetChargingPointOperatorsResponse>) => {
        return response.data;
      });
  }
}

export default ChargingPointHttp;
